/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core"
import _ from 'lodash'
import { useContext } from 'react'
import FeedbackButton from "./Feedback/FeedbackButton"
import { AuthContext } from "../../AuthProvider"
import { Link } from "react-router-dom"

function LandingHeader() {
  const { subscription } = useContext(AuthContext);
  
  return (
    <header className="header" id="header-id">
      <div className="flex header-inner">
        <div className="header-left">
          
        </div>
        <div className="heder-midle">
        </div>

         <div className="header-right">
          {/*<div className="head-temp">

            <figure> <CloudImg /> </figure>

            <span className="temperature" style={{ color: theme == "dark" ? "white" : "" , opacity : theme == "dark" ? 0.3 :"" }}>{
              loader ? <span className="loaderTemp"></span> : (isNaN(temperature) ? null : <span>{parseInt(temperature)}{' C'}</span>)
            }</span>
            <span className="weatherType">Cloudy</span>
          </div>*/}
          {/* <GroupByDropdown /> */}
          {
            subscription?.isFreeTrial
            && 
            <Link className="btn upgrade-plan-btn" to="/subscription-plan" css={{
              background: `linear-gradient(0deg,rgba(var(--theme-mode-rgb-white),0.6),rgba(var(--theme-mode-rgb-white),0.6)),linear-gradient(0deg,var(--accent-color),var(--accent-color)),linear-gradient(0deg,rgba(var(--theme-mode-rgb-white),0.05),rgba(var(--theme-mode-rgb-white),0.05)),var(--theme-mode-color-white)`
            }}>
              <span css={{
                background: `linear-gradient(rgba(var(--theme-mode-rgb-white-reverse), 0.5), rgba(var(--theme-mode-rgb-white-reverse), 0.5)), var(--accent-color)`,
                WebkitTextFillColor: 'transparent',
                WebkitBackgroundClip: 'text !important'
              }}>Upgrade</span> {subscription?.daysLeft} {subscription?.daysLeft > 1 ? 'days' : 'day'} left
            </Link>
          }
          <FeedbackButton />
        </div> 
      </div>
    </header>
  )
}

export default LandingHeader
